import * as XLSX from 'xlsx';
import { compareSummaries } from './posRevenueComparison';

export function comparisonExportRows(model, t) {
  const headers = [t('comparison_item'), t('comparison_metric'), t('comparison_p1'), t('comparison_p2'), t('comparison_delta'), t('comparison_percent')];
  const metric = (name, label, data) => [name, label, data.a, data.b, data.delta, data.percent];
  return {
    totals: [headers, metric(t('comparison_global'), t('total_revenue'), model.revenue), metric(t('comparison_global'), t('products_sold'), model.quantity)],
    categories: [[t('comparison_category'), t('comparison_p1'), t('comparison_p2'), t('comparison_delta'), t('comparison_percent'), t('comparison_share1'), t('comparison_share2'), t('comparison_points')],
      ...model.categories.map((category) => [category.name, category.revenue.a, category.revenue.b, category.revenue.delta, category.revenue.percent, category.shareA, category.shareB, category.shareDelta])],
    products: [headers, ...model.products.flatMap((product) => [
      metric(`${product.name} (${product.category})`, t('products_sold'), product.quantity),
      metric(`${product.name} (${product.category})`, t('revenue'), product.revenue),
    ])],
  };
}
export function buildComparisonWorkbook({ results, organizations, paymentMethod, t, formatDate }) {
  const workbook = XLSX.utils.book_new();
  const rows = comparisonExportRows(compareSummaries(results.a, results.b, paymentMethod), t);
  const metadata = [
    [t('comparison_p1'), ...results.period1.map(formatDate)],
    [t('comparison_p2'), ...results.period2.map(formatDate)],
    [t('comparison_organizations'), organizations.map((org) => org.organization || org.id).join(', ')],
    [t('comparison_payment'), paymentMethod || 'all'],
    [t('comparison_mixed_note')],
  ];
  const used = new Set();
  const append = (data, name) => {
    const base = name.replace(/[\\/?*\[\]:]/g, ' ').slice(0, 25) || 'Sheet';
    let title = base, number = 1;
    while (used.has(title.toLowerCase())) title = `${base} ${++number}`;
    used.add(title.toLowerCase());
    const sheet = XLSX.utils.aoa_to_sheet(data);
    sheet['!cols'] = Array.from({ length: 8 }, (_, index) => ({ wch: index === 0 ? 38 : 22 }));
    XLSX.utils.book_append_sheet(workbook, sheet, title);
  };
  append(metadata, t('comparison_filters'));
  append(rows.totals, t('comparison_totals'));
  append(rows.categories, t('comparison_categories'));
  append(rows.products, t('comparison_products'));
  for (const org of organizations) {
    const model = compareSummaries(results.a.byOrganization?.[org.id], results.b.byOrganization?.[org.id], paymentMethod);
    const data = comparisonExportRows(model, t);
    append([...data.totals, [], ...data.categories, [], ...data.products], org.organization || org.id);
  }
  return workbook;
}
export function exportPosComparison(options) {
  XLSX.writeFile(buildComparisonWorkbook(options), 'POS_Comparison.xlsx');
}
